import {
	GET_SCHEDULED_REMINDERS,
	FETCH_SCHEDULED_REMINDER,
	ADD_SCHEDULED_REMINDER,
	EDIT_SCHEDULED_REMINDER,
	DELETE_SCHEDULED_REMINDER,
	CLEAR_SCHEDULED_REMINDERS,
} from "constants/actions";

const initialState = {
	scheduledReminders: [],
	pending: false,
};

export default function ActionReminders(state = initialState, action) {
	switch (action.type) {
		case GET_SCHEDULED_REMINDERS:
			return {
				...state,
				scheduledReminders: action.payload,
				pending: false,
			};

		case FETCH_SCHEDULED_REMINDER:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case ADD_SCHEDULED_REMINDER:
		case EDIT_SCHEDULED_REMINDER:
			if (state.scheduledReminders && Array.isArray(state.scheduledReminders)) {
				const exists = state.scheduledReminders.find((r) => r.id === action.payload.id);
				const scheduledReminders = exists
					? state.scheduledReminders.map((r) => (r.id === action.payload.id ? action.payload : r))
					: [...state.scheduledReminders, action.payload];

				return {
					...state,
					scheduledReminders,
					[action.payload.id]: action.payload,
					pending: false,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case DELETE_SCHEDULED_REMINDER:
			return {
				...state,
				scheduledReminders: (state.scheduledReminders || []).filter((row) => row.id !== action.payload),
				pending: false,
			};

		case CLEAR_SCHEDULED_REMINDERS:
			return initialState;

		default:
			return state;
	}
}

